import { Badge, BadgeProps } from "@/components/ui/badge"
import { capitalizeFirstLetter } from "@/lib/utils"

interface ReviewStatusBadgeProps {
    content: string
    status: string
}

const isValidVariant = (
    status: string
): status is NonNullable<BadgeProps["variant"]> => {
    return [
        "new",
        "review",
        "accepted",
        "declined",
        "category-a",
        "category-b",
        "category-c",
        "category-d",
        "complete",
        "incomplete",
        "age-group",
    ].includes(status)
}

export default function ReviewStatusBadge(props: ReviewStatusBadgeProps) {
    return (
        <Badge
            variant={isValidVariant(props.status) ? props.status : "default"}
        >
            {capitalizeFirstLetter(props.content)}
        </Badge>
    )
}
